import React, { lazy } from 'react';

const DigitalReportingSubmenu = lazy(() =>
  import('./DigitalReportingSubmenu').then(module => ({
    default: module.DigitalReportingSubmenu,
  })),
);

const digitalReportingRoutes = [
  {
    props: { exact: true, path: '/digital-reporting' },
    component: <DigitalReportingSubmenu />,
  },
];

export default digitalReportingRoutes;
